import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Policies from './pages/Policies';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Reports from './pages/Reports';
import Companies from './pages/Companies';
import Branches from './pages/Branches';
import GoverningBodies from './pages/GoverningBodies';
import CompanyDetail from './pages/CompanyDetail';
import BranchDetail from './pages/BranchDetail';
import Claims from './pages/Claims';
import AuditLogs from './pages/AuditLogs';
import SystemMonitoring from './pages/SystemMonitoring';
import SecurityMonitoring from './pages/SecurityMonitoring';
import CarDataManagement from './components/CarDataManagement';
import InsuranceTypes from './pages/InsuranceTypes';
import CommissionReports from './pages/CommissionReports';
import EmailSettings from './pages/EmailSettings';
import EmailHistory from './pages/EmailHistory';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <AuthProvider>
      <PermissionProvider>
        <LanguageProvider>
          <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes with shared layout */}
            <Route element={
                <ProtectedRoute>
                <DashboardLayout>
                  <Outlet />
                </DashboardLayout>
                </ProtectedRoute>
            }>
              <Route path="/dashboard" element={<Dashboard />} />
              {/* Client routes removed - client data now embedded in policies */}
              <Route path="/policies" element={<Policies />} />
              <Route path="/claims" element={<Claims />} />
              <Route path="/claims/new" element={<Claims />} />
              <Route path="/claims/:id" element={<Claims />} />
              <Route path="/documents" element={<Documents />} />
              
              {/* Admin only routes */}
              <Route path="/users" element={
                <ProtectedRoute roles={['admin']}>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="/companies" element={
                <ProtectedRoute roles={['admin', 'governing_body']}>
                  <Companies />
                </ProtectedRoute>
              } />
              <Route path="/companies/:id" element={
                <ProtectedRoute roles={['admin', 'governing_body', 'company']}>
                  <CompanyDetail />
                </ProtectedRoute>
              } />
              <Route path="/governing-bodies" element={
                <ProtectedRoute roles={['admin']}>
                  <GoverningBodies />
                </ProtectedRoute>
              } />
              <Route path="/branches" element={
                <ProtectedRoute roles={['admin', 'governing_body', 'company']}>
                  <Branches />
                </ProtectedRoute>
              } />
              <Route path="/branches/:id" element={
                <ProtectedRoute roles={['admin', 'company', 'branch']}>
                  <BranchDetail />
                </ProtectedRoute>
              } />
              <Route path="/reports" element={
                <ProtectedRoute roles={['admin', 'governing_body', 'company', 'branch']}>
                  <Reports />
                </ProtectedRoute>
              } />
              <Route path="/roles" element={
                <ProtectedRoute roles={['admin']}>
                  <Roles />
                </ProtectedRoute>
              } />
              <Route path="/audit-logs" element={
                <ProtectedRoute roles={['admin']}>
                  <AuditLogs />
                </ProtectedRoute>
              } />
              <Route path="/system-monitoring" element={
                <ProtectedRoute roles={['admin']}>
                  <SystemMonitoring />
                </ProtectedRoute>
              } />
              <Route path="/security-monitoring" element={
                <ProtectedRoute roles={['admin']}>
                  <SecurityMonitoring />
                </ProtectedRoute>
              } />
              <Route path="/car-data" element={
                <ProtectedRoute roles={['admin', 'governing_body', 'company', 'branch']}>
                  <CarDataManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/insurance-types" element={
                <ProtectedRoute roles={['admin']}>
                  <InsuranceTypes />
                </ProtectedRoute>
              } />
              <Route path="/admin/commissions" element={
                <ProtectedRoute roles={['admin']}>
                  <CommissionReports />
                </ProtectedRoute>
              } />
              <Route path="/admin/email-settings" element={
                <ProtectedRoute roles={['admin']}>
                  <EmailSettings />
                </ProtectedRoute>
              } />
              <Route path="/admin/email-history" element={
                <ProtectedRoute roles={['admin']}>
                  <EmailHistory />
                </ProtectedRoute>
              } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </Router>
      </LanguageProvider>
      </PermissionProvider>
    </AuthProvider>
  );
}

export default App;